module.exports = __webpack_public_path__ + "img/delano1.f5aa2ad9.jpg";